import { Pagination } from "api/models/response/pagination";
import { flow, types } from "mobx-state-tree";
import { withRootStore } from "mobx-stores/_extension/with-root-store";

import { dualLangInspectionNoteBusiness } from "api/bussiness/inspection-note/dual-lang-inspection-note/dual-lang-inspection-note-business";
import { GetInpsectionNotes } from "api/models/request/inspection-note/inspection-note";
import { withReset } from "mobx-stores/_extension/with-reset";

import {
  DualLangInspectionNote,
  IDualLangInspectionNoteProperties,
} from "mobx-stores/_models/inspection-note/dual-lang-inspection-note/dual-lang-inspection-note";

import { withSetPropAction } from "../_extension/with-set-props";
import { DateRangeFilterStore } from "./common/date-range-filter-store";
import { PaginationStore } from "./common/pagination-store";

export const DualLangInspectionPrintingManagement = types
  .model({
    open: false,
  })
  .actions(withSetPropAction)
  .actions(withReset);

export const DualLangInspectionNoteQueryParams = types
  .model({
    number: "",
    dateRangeFilter: types.optional(DateRangeFilterStore, {}),
    name: "",
    dealingName: "",
  })
  .actions(withSetPropAction);
export const DualLangInspectionNoteManagement = types
  .model({
    dualLangInspectionNotes: types.optional(
      types.array(DualLangInspectionNote),
      []
    ),
    pagination: types.optional(PaginationStore, {}),
    dualLangInspectionNoteDetail: types.maybeNull(DualLangInspectionNote),
    openNew: false,
    openEdit: false,
    openDelete: false,
    queryParams: types.optional(DualLangInspectionNoteQueryParams, {}),
    dualLangInspectionPrintingManagement: types.optional(
      DualLangInspectionPrintingManagement,
      {}
    ),
  })
  .extend(withRootStore)
  .actions(withSetPropAction)
  .actions((self) => ({
    getDualLangInspectionNotes: flow(function* getStellaInspectionNotes(
      request?: GetInpsectionNotes
    ) {
      try {
        self._rootStore.setProp("inProgress", true);
        if (!request) {
          request = {
            filter: self.pagination.filter,
            maxResultCount: self.pagination.itemsPerPage,
            skipCount: self.pagination.skipCount,
            sorting: "",
            number: self.queryParams.number,
            dealingName: self.queryParams.dealingName,
            fromDate:
              self.queryParams.dateRangeFilter.fromAsDayJs?.isValid() &&
              self.queryParams.dateRangeFilter.from
                ? self.queryParams.dateRangeFilter.from
                : undefined,
            toDate:
              self.queryParams.dateRangeFilter.toAsDayJs?.isValid() &&
              self.queryParams.dateRangeFilter.to
                ? self.queryParams.dateRangeFilter.to
                : undefined,
            name: self.queryParams.name,
          };
        }
        const res =
          (yield dualLangInspectionNoteBusiness.getLists<GetInpsectionNotes>(
            request
          )) as Pagination<IDualLangInspectionNoteProperties>;
        self.setProp(
          "dualLangInspectionNotes",
          res.items?.map((x, i) => ({
            ...x,
            orderNumber:
              i + 1 + self.pagination.pageIndex * self.pagination.itemsPerPage,
          }))
        );
        self.pagination.setProp("totalItems", res.totalCount);
      } catch (ex) {
        console.error(ex);
      } finally {
        self._rootStore.setProp("inProgress", false);
      }
    }),
    getDualLangInspectionNoteDetail: flow(
      function* getStellaInspectionNoteDetail(id: string) {
        try {
          self._rootStore.setProp("inProgress", true);
          const res = (yield dualLangInspectionNoteBusiness.getById(
            id
          )) as IDualLangInspectionNoteProperties;
          self.setProp("dualLangInspectionNoteDetail", res);
        } catch (ex) {
          console.error(ex);
        } finally {
          self._rootStore.setProp("inProgress", false);
        }
      }
    ),
  }));
